import { DatasetForm } from "@/modules/dataset-form";
import {
  useInterventionSectionDatasetForm,
  useInterventionSectionDatasetImage,
} from "@/modules/intervention/intervention-section-datasets";

export const InterventionSectionForm = () => {
  const { key, disabled, template, dataset, loading } =
    useInterventionSectionDatasetForm();
  const images = useInterventionSectionDatasetImage();

  return (
    <DatasetForm
      key={key}
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
      datasetsImage={images.datasets}
      datasetsImageLoading={images.loading}
    />
  );
};
